(() => {
  const requestedTopic = new URLSearchParams(location.search).get('anliegen');
  const topicAliases = {
    mengenrabatt: 'bulk',
    kooperation: 'cooperation',
    bestellung: 'order',
    produkt: 'product',
    einrichtung: 'setup'
  };

  document.querySelectorAll('.origin-contact__form').forEach((form) => {
    const topic = form.querySelector('[name="contact[Anliegen]"]');
    if (!topic || form.dataset.contactReady) return;
    form.dataset.contactReady = 'true';

    const groups = form.querySelectorAll('[data-contact-fields]');
    const requestedOption = Array.from(topic.options).find(
      (option) => option.dataset.contactTopic === topicAliases[requestedTopic]
    );
    if (!topic.value && requestedOption) topic.value = requestedOption.value;

    const updateFields = () => {
      const selectedTopic = topic.selectedOptions[0]?.dataset.contactTopic;
      groups.forEach((group) => {
        const active = group.dataset.contactFields === selectedTopic;
        group.hidden = !active;
        group.disabled = !active;
      });
    };

    topic.addEventListener('change', updateFields);
    window.addEventListener('pageshow', updateFields);
    form.addEventListener('reset', () => queueMicrotask(updateFields));
    updateFields();
  });
})();
